import { render, staticRenderFns } from "./FreezeApplicant.vue?vue&type=template&id=7c3328fe"
import script from "./FreezeApplicant.vue?vue&type=script&lang=js"
export * from "./FreezeApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports